export default {
  setSelections(state, val) {
    console.debug(val.selections);
    state.selections = val.selections
  }
}



// WEBPACK FOOTER //
// ./src/Homepage/store/mutations.js